// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
export type FeaturesFragment = (
  { __typename?: 'OrganisationFeatures' }
  & Pick<PrivateSchemaTypes.OrganisationFeatures, 'campaigns' | 'campaign_templating' | 'dashboards' | 'custom_email_sender_address' | 'campaign_manager_notification' | 'campaigns_event_filters' | 'campaigns_archive_cert_enrolments_after_user_leave' | 'custom_i18n' | 'custom_smtp' | 'search_analytics' | 'SCORM' | 'Slack' | 'Fourth' | 'sms' | 'account_name_login' | 'msteams' | 'certificates' | 'bongo' | 'gsuite' | 'microsoft_365' | 'multiple_senders' | 'video_analytics' | 'calendars_integration' | 'secret_signup' | 'instant_sso_login' | 'analytics_use_archived_data_from_snapshots'>
  & { hotjar?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'HotjarSetup' }
    & Pick<PrivateSchemaTypes.HotjarSetup, 'enabled' | 'site_id'>
  )>, link_unfurling?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'LinkUnfurlingData' }
    & Pick<PrivateSchemaTypes.LinkUnfurlingData, 'enabled' | 'switched_on'>
  )>, cpd?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'CPDData' }
    & Pick<PrivateSchemaTypes.CpdData, 'enabled' | 'switched_on'>
  )> }
);

export const FeaturesFragmentDoc = gql`
    fragment features on OrganisationFeatures {
  campaigns
  campaign_templating
  dashboards
  custom_email_sender_address
  campaign_manager_notification
  campaigns_event_filters
  campaigns_archive_cert_enrolments_after_user_leave
  custom_i18n
  custom_smtp
  search_analytics
  SCORM
  Slack
  Fourth
  sms
  account_name_login
  msteams
  certificates
  hotjar {
    enabled
    site_id
  }
  link_unfurling {
    enabled
    switched_on
  }
  cpd {
    enabled
    switched_on
  }
  bongo
  gsuite
  microsoft_365
  multiple_senders
  video_analytics
  calendars_integration
  secret_signup
  instant_sso_login
  analytics_use_archived_data_from_snapshots
}
    `;